/** Central query-key factory so services/websocket.ts and hooks stay in sync. */
export const queryKeys = {
  torrentsRoot: ['torrents'] as const,
  torrents: <T extends object>(params: T = {} as T) => ['torrents', 'list', params] as const,
  torrent: (id: string) => ['torrents', 'detail', id] as const,
  torrentFiles: (id: string) => ['torrents', 'detail', id, 'files'] as const,
  torrentPeers: (id: string) => ['torrents', 'detail', id, 'peers'] as const,
  torrentTrackers: (id: string) => ['torrents', 'detail', id, 'trackers'] as const,

  activityRoot: ['activity'] as const,
  activity: <T extends object>(params: T = {} as T) => ['activity', 'list', params] as const,

  health: ['health'] as const,
  storage: ['storage'] as const,
};
